export const names = Object.freeze({
  login: "Login",
  redirect: "Redirect",
  loginVcm: "LoginVcm",
  redirectVcm: "RedirectVcm",
  logout: "Logout",
});
